/**
 * Parse JSON to a stylable HTML format.
 *
 * @param {string} input The JSON to parse.
 *
 * @return {string} The parsed JSON.
 */
export default (input) => {
  const json = JSON.stringify(input, null, 2)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

  // Replace each element for a span with a class name.
  return json.replace(
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
    (match) => {
      let className = 'number';

      // Key or string.
      if (/^"/.test(match)) {
        className = 'string';

        if (/:$/.test(match)) {
          className = 'key';
        }
      }

      // Boolean.
      if (/true|false/.test(match)) {
        className = 'boolean';
      }

      // Null.
      if (/null/.test(match)) {
        className = 'null';
      }

      return `<span class="${className}">${match}</span>`;
    },
  );
};
